import React from "react";

export * from "./common";

export const BookNowButton = React.lazy(() => import("./book-now-button/BookNowButton"));
export const TopHeader = React.lazy(() => import("./top-header/TopHeader"));
